<script lang="ts">
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';

	import { Button, ButtonV2, Modal, Stack, Text } from '@Shelly/shelly-design-system';

	export let showModal = false;
	export let homeName = '';
	export let loading = false;
	/** When true, render the V2 button variant; otherwise the legacy one. */
	export let useV2 = false;

	const dispatch = createEventDispatcher<{ confirm: void; close: void }>();

	$: ButtonComponent = useV2 ? ButtonV2 : Button;

	function onClose(): void {
		if (loading) return;
		showModal = false;
		dispatch('close');
	}

	function onConfirm(): void {
		if (loading) return;
		dispatch('confirm');
	}
</script>

<Modal
	{showModal}
	on:close={onClose}
	title={$format('transfer_unit_already_shared_title', {
		default: 'Already shared with this account',
	})}
>
	<svelte:fragment slot="content">
		<Stack gap="m">
			<Text>
				{$format('transfer_unit_already_shared_message', {
					default:
						'{homeName} is already shared, so ownership cannot be transferred yet. If you proceed, we will remove the shared access to this home and send a transfer offer.',
					values: { homeName },
				})}
			</Text>
			<Text>
				{$format('transfer_unit_already_shared_proceed_question', {
					default: 'Do you want to proceed?',
				})}
			</Text>
		</Stack>
	</svelte:fragment>

	<div slot="footer" class="d-flex justify-content-end">
		<svelte:component
			this={ButtonComponent}
			width={useV2 ? undefined : 'm'}
			variant="secondary"
			class="mr-s"
			disabled={loading}
			aria-label={$format('button_cancel', { default: 'Cancel' })}
			on:click={onClose}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</svelte:component>
		<svelte:component
			this={ButtonComponent}
			width={useV2 ? undefined : 'm'}
			variant="primary"
			{loading}
			disabled={loading}
			aria-label={$format('transfer_unit_already_shared_confirm', {
				default: 'Proceed',
			})}
			on:click={onConfirm}
		>
			{$format('transfer_unit_already_shared_confirm', {
				default: 'Proceed',
			})}
		</svelte:component>
	</div>
</Modal>
